import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet, IonSpinner } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MarvHistoryService } from '@marv/services';
import { MenuComponent, AlertModalComponent } from '@app/components';
import { AgencyService, IconsService, GoogleMapsService, MenuService, DataService } from '@app/services';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
    styleUrls: ['./app.component.scss'],
  imports: [IonApp, IonRouterOutlet, IonSpinner, TranslatePipe, MenuComponent, AlertModalComponent],
})
export class AppComponent {
    
    isFetchingData: boolean = false;
    isFetchingDataSubscription: Subscription;
    
    constructor(
        private marvHistoryService: MarvHistoryService,
        private agencyService: AgencyService,
        private iconsService: IconsService,
        private googleMapsService: GoogleMapsService,
        public menuService: MenuService,
        private dataService: DataService
    ) {
        marvHistoryService.init();
        agencyService.init();
        iconsService.init();
        googleMapsService.init();  
    }
    
    ngOnInit() {
        this.isFetchingData = !this.dataService.initData;
        this.isFetchingDataSubscription = this.dataService.isFetchingData.subscribe((isFetching) => {
            this.isFetchingData = isFetching;
        });
    }
    
    ngOnDestroy() {
        if(this.isFetchingDataSubscription){
            this.isFetchingDataSubscription.unsubscribe();
        } 
    }
}
